import axios from "axios";


const BASE_URL = process.env.REACT_APP_API_URL + '/api/employee';
export const updateUserProfile = async (employeeId, formData) => {
  try {
    const response = await axios.post(`${BASE_URL}/${employeeId}`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
